<template>
    <div class="field-colorscheme-wrapper">
        <div class="field-colorgroup">
            <ul class="field-colorgroup__list">
                <li
                    v-for="colorgroup__value in getColorgroups"
                    v-bind:key="'colorgroup_' + colorgroup__value.id"
                    class="field-colorgroup__list-item"
                >
                    <input
                        type="radio"
                        class="field-colorgroup__input"
                        v-on:change="colorgroupToggler"
                        :id="'colorgroup_' + colorgroup__value.id"
                        :value="colorgroup__value.id"
                        :name="'colorgroup_radios'"
                        :checked="colorgroup__value.id == getActiveColorgroupId"
                    />
                    <label
                        :for="'colorgroup_' + colorgroup__value.id"
                        class="field-colorgroup__label"
                    >
                        <span class="field-colorgroup__pseudo-radio"></span>
                        <div
                            v-tooltip="
                                colorgroup__value.type === 'legacy'
                                    ? 'Zurück zum alten Farbschema'
                                    : colorgroup__value.type === 'logo'
                                    ? 'Farbschema aus Logo'
                                    : colorgroup__value.type === 'custom'
                                    ? 'Individuelle Farben'
                                    : null
                            "
                            class="field-colorgroup__color"
                            v-bind:class="'colorgroup__color-preview--' + colorgroup__value.id"
                        >
                            <img
                                v-if="
                                    colorgroup__value.type === 'logo' &&
                                        getProp('deha.user.misc.logo.id')
                                "
                                v-bind:src="
                                    generateMediaUrl({
                                        id: getProp('deha.user.misc.logo.id'),
                                        h: 50
                                    })
                                "
                                alt=""
                            />
                        </div>
                    </label>
                </li>
            </ul>
        </div>

        <div class="field-colorscheme" v-if="getActiveColorgroupId">
            <div class="field-colorscheme__groups">
                <div v-if="getActiveColorscheme === 'custom'">
                    <app-colorpicker
                        label="Primär-Farbe"
                        :value="getCustomColor(1)"
                        @input="setCustomColor({ id: 1, value: $event })"
                    ></app-colorpicker>
                    <app-colorpicker
                        label="Sekundär-Farbe"
                        :value="getCustomColor(2)"
                        @input="setCustomColor({ id: 2, value: $event })"
                    ></app-colorpicker>
                    <app-colorpicker
                        label="Kontrast-Farbe"
                        :value="getCustomColor(3)"
                        @input="setCustomColor({ id: 3, value: $event })"
                    ></app-colorpicker>
                </div>

                <ul v-else class="field-colorscheme__list">
                    <li
                        v-for="colorschemes__value in colorschemesInActiveColorgroup"
                        v-bind:key="id + '_' + getActiveColorgroupId + '_' + colorschemes__value.id"
                        class="field-colorscheme__list-item"
                    >
                        <span
                            class="field-colorscheme__item-id"
                            v-html="
                                '#' +
                                    (!isNaN(getActiveColorscheme)
                                        ? ('000' + colorschemes__value.id).slice(-3)
                                        : 'c' + ('000' + colorschemes__value.id).slice(-2))
                            "
                        ></span>

                        <input
                            v-if="!isNaN(getActiveColorscheme)"
                            type="radio"
                            class="field-colorscheme__input"
                            v-model="simpleFieldModel"
                            :id="id + '_' + getActiveColorgroupId + '_' + colorschemes__value.id"
                            :value="colorschemes__value.id"
                            :name="'colorscheme_radios'"
                        />
                        <input
                            v-else
                            type="radio"
                            class="field-colorscheme__input"
                            v-on:change="setLogoColorActive(colorschemes__value.id)"
                            :id="id + '_' + getActiveColorgroupId + '_' + colorschemes__value.id"
                            :value="colorschemes__value.id"
                            :name="'colorscheme_radios'"
                            :checked="colorschemes__value.id == getLogoColorsActiveId"
                        />

                        <label
                            :for="id + '_' + getActiveColorgroupId + '_' + colorschemes__value.id"
                            class="field-colorscheme__label"
                        >
                            <span class="field-colorscheme__pseudo-radio"></span>
                            <div class="colorscheme__color-preview-box">
                                <div class="colorscheme__color-preview-box-header">
                                    <div
                                        class="color-preview--secondary"
                                        v-bind:style="{
                                            backgroundColor: getColorschemeColor(
                                                !isNaN(getActiveColorscheme)
                                                    ? colorschemes__value.id
                                                    : 'logo.' + colorschemes__value.id,
                                                2
                                            )
                                        }"
                                    ></div>
                                    <div
                                        class="color-preview--primary"
                                        v-bind:style="{
                                            backgroundColor: getColorschemeColor(
                                                !isNaN(getActiveColorscheme)
                                                    ? colorschemes__value.id
                                                    : 'logo.' + colorschemes__value.id,
                                                1
                                            )
                                        }"
                                    ></div>
                                    <div
                                        class="color-preview--contrast"
                                        v-bind:style="{
                                            backgroundColor: getColorschemeColor(
                                                !isNaN(getActiveColorscheme)
                                                    ? colorschemes__value.id
                                                    : 'logo.' + colorschemes__value.id,
                                                3
                                            )
                                        }"
                                    ></div>
                                </div>
                                <div class="colorscheme__color-preview-box-footer">
                                    <div
                                        class="color-preview--white"
                                        v-bind:style="{
                                            backgroundColor: getColorschemeColor(
                                                !isNaN(getActiveColorscheme)
                                                    ? colorschemes__value.id
                                                    : 'logo.' + colorschemes__value.id,
                                                13
                                            )
                                        }"
                                    ></div>
                                    <div
                                        class="color-preview--gray"
                                        v-bind:style="{
                                            backgroundColor: getColorschemeColor(
                                                !isNaN(getActiveColorscheme)
                                                    ? colorschemes__value.id
                                                    : 'logo.' + colorschemes__value.id,
                                                11
                                            )
                                        }"
                                    >
                                        <div
                                            class="color-preview--darkgray"
                                            v-bind:style="{
                                                backgroundColor: getColorschemeColor(
                                                    !isNaN(getActiveColorscheme)
                                                        ? colorschemes__value.id
                                                        : 'logo.' + colorschemes__value.id,
                                                    11
                                                )
                                            }"
                                        ></div>
                                        <div
                                            class="color-preview--black"
                                            v-bind:style="{
                                                backgroundColor: getColorschemeColor(
                                                    !isNaN(getActiveColorscheme)
                                                        ? colorschemes__value.id
                                                        : 'logo.' + colorschemes__value.id,
                                                    10
                                                )
                                            }"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>

            <div class="field-colorscheme__group-preview" v-if="getActiveColorscheme">
                <div class="colorscheme__color-preview-box colorscheme__color-preview-box--big">
                    <span
                        v-if="!isNaN(getActiveColorscheme) || getActiveColorscheme === 'logo'"
                        class="field-colorscheme__item-id"
                        v-html="
                            '#' +
                                (!isNaN(getActiveColorscheme)
                                    ? ('000' + getActiveColorscheme).slice(-3)
                                    : 'c' + ('000' + getLogoColorsActiveId).slice(-2))
                        "
                    ></span>
                    <div class="colorscheme__color-preview-box-header">
                        <div
                            class="color-preview--secondary"
                            v-bind:style="{
                                backgroundColor: getColorschemeColor(getActiveColorscheme, 2)
                            }"
                        >
                            <span class="field-colorscheme__item-color-label">
                                Sekundär-Farbe
                            </span>
                        </div>
                        <div
                            class="color-preview--primary"
                            v-bind:style="{
                                backgroundColor: getColorschemeColor(getActiveColorscheme, 1)
                            }"
                        >
                            <span class="field-colorscheme__item-color-label">
                                Primär-Farbe
                            </span>
                        </div>
                        <div
                            class="color-preview--contrast"
                            v-bind:style="{
                                backgroundColor: getColorschemeColor(getActiveColorscheme, 3)
                            }"
                        >
                            <span class="field-colorscheme__item-color-label">
                                Kontrast-Farbe
                            </span>
                        </div>
                    </div>
                    <div class="colorscheme__color-preview-box-footer">
                        <div
                            class="color-preview--white"
                            v-bind:style="{
                                backgroundColor: getColorschemeColor(getActiveColorscheme, 13)
                            }"
                        ></div>
                        <div
                            class="color-preview--gray"
                            v-bind:style="{
                                backgroundColor: getColorschemeColor(getActiveColorscheme, 12)
                            }"
                        >
                            <div
                                class="color-preview--darkgray"
                                v-bind:style="{
                                    backgroundColor: getColorschemeColor(getActiveColorscheme, 11)
                                }"
                            ></div>
                            <div
                                class="color-preview--black"
                                v-bind:style="{
                                    backgroundColor: getColorschemeColor(getActiveColorscheme, 10)
                                }"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pushid from 'pushid';
import Colorpicker from '@/components/fields/simple/Colorpicker.vue';
import { mapActions, mapGetters } from 'vuex';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {
        'app-colorpicker': Colorpicker
    },
    methods: {
        ...mapActions([
            'setLogoColorActive',
            'setCustomColorsDefault',
            'setCustomColor',
            'saveColorsFromCurrentLogo'
        ]),
        colorgroupToggler(event) {
            let colorgroup = this.getColorgroup(event.target.value);
            if (colorgroup.type === 'logo') {
                this.simpleFieldSet('logo');
                this.setLogoColorActive(1);
            } else if (colorgroup.type === 'custom') {
                this.setCustomColorsDefault();
                this.simpleFieldSet('custom');
                this.setLogoColorActive(null);
            } else {
                this.simpleFieldSet(
                    this.getColorschemes.filter((i) => i.group == colorgroup.id)[0].id
                );
                this.setLogoColorActive(null);
            }
        }
    },
    computed: {
        ...mapGetters([
            'getColorgroups',
            'getColorgroup',
            'getColorschemes',
            'getLogoColorsActiveId',
            'getColorschemeColor',
            'getActiveColorscheme',
            'getActiveColorgroupId',
            'getCustomColor',
            'colorschemesInActiveColorgroup',
            'getProp',
            'generateMediaUrl'
        ])
    },
    created() {
        // if logo was uploaded previously and no data has been stored yet
        let colors_logo = this.getProp('tecpage.user.settings.misc.colors_logo');
        if (colors_logo === undefined || colors_logo === null || colors_logo === '') {
            this.saveColorsFromCurrentLogo();
        }
    },
    mixins: [SimpleFieldMixin],
    props: {}
};
</script>
